<script setup>
import '@campact/camper/core/CmprTicker';

defineProps({
  items: {
    type: Array,
    default() {
      return [];
    },
  },
});

</script>

<template>
  <div
    v-if="items.length"
    class="ticker"
  >
    <cmpr-ticker variant="light">
      <cmpr-ticker-item
        v-for="(item, index) in items"
        :key="index"
        :event="item.event"
        :timestamp="item.timestamp"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="item.text" />
      </cmpr-ticker-item>
    </cmpr-ticker>
  </div>
</template>

<style scoped lang="scss">
@import '@cta/frontend/stylesheets/custom-media';

.ticker {
  display: none;

  @media (--cmpr-breakpoint-desktop-min) {
    display: initial;
  }
}
</style>
